import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Form from "@saleor/components/Form";
import Hr from "@saleor/components/Hr";
import Skeleton from "@saleor/components/Skeleton";
import {
  Timeline,
  TimelineAddNote,
  TimelineNote
} from "@saleor/components/Timeline";
import { InsCommentDetail_commentById_comments } from "@saleor/inscomment/types/InsCommentDetail";
import React from "react";
import { FormattedMessage } from "react-intl";

interface InsCommentHistoryProps {
  history: InsCommentDetail_commentById_comments[];
  onNoteAdd: (data: FormData) => void;
}
const useStyles = makeStyles(
  theme => ({
    header: {
      fontWeight: 500,
      marginBottom: theme.spacing(1)
    },
    root: { marginTop: theme.spacing(4) },
    user: {
      marginBottom: theme.spacing(1)
    }
  }),
  { name: "OrderHistory" }
);

export interface FormData {
  message: string;
}
const InsCommentHistory: React.FC<InsCommentHistoryProps> = props => {
  const { history, onNoteAdd } = props;
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      <Typography className={classes.header} color="textSecondary">
        <FormattedMessage defaultMessage="InsComment Note" />
      </Typography>
      <Hr />
      {history ? (
        <Timeline>
          <Form initial={{ message: "" }} onSubmit={onNoteAdd} resetOnSubmit>
            {({ change, data, reset, submit }) => (
              <TimelineAddNote
                message={data.message}
                reset={reset}
                onChange={change}
                onSubmit={submit}
              />
            )}
          </Form>
          {history
            .slice()
            .reverse()
            .map(comment => (
              <TimelineNote
                date={comment.created}
                user={{ email: comment.userName }}
                message={comment.text}
                key={comment.id}
              />
            ))}
        </Timeline>
      ) : (
        <Skeleton />
      )}
    </div>
  );
};
InsCommentHistory.displayName = "InsCommentHistory";
export default InsCommentHistory;
